import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import PinAuth from './components/PinAuth';
import DevisForm from './components/DevisForm';
import { Server } from './services/api';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentServer, setCurrentServer] = useState<Server | null>(null);

  const handlePinSuccess = (server: Server) => {
    setCurrentServer(server);
    setIsAuthenticated(true);
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route 
            path="/" 
            element={
              isAuthenticated ? (
                <Navigate to="/devis" replace />
              ) : (
                <PinAuth onPinSuccess={handlePinSuccess} />
              )
            } 
          />
          <Route 
            path="/devis" 
            element={
              isAuthenticated && currentServer ? (
                <DevisForm server={currentServer} />
              ) : (
                <Navigate to="/" replace />
              )
            } 
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
